/**
 * WordPress dependencies
 */
import {
    __experimentalAlignmentHookSettingsProvider as AlignmentHookSettingsProvider,
    InnerBlocks,
    BlockControls,
    BlockAlignmentToolbar,
    useBlockProps, 
    InspectorControls,
} from '@wordpress/block-editor';
import {useRef, useEffect, useState,useCallback} from '@wordpress/element';
import {each, times, reduce} from 'lodash';
import {Button, ExternalLink, PanelBody, TextareaControl, ToggleControl, ToolbarGroup,__experimentalNumberControl as NumberControl} from '@wordpress/components';
import {__} from '@wordpress/i18n';
import {dispatch, select, useSelect} from '@wordpress/data';
import {createBlock} from '@wordpress/blocks';
/**
 * Internal dependencies
 */
import Slider from "react-slick";

import {pullLeft, pullRight} from '@wordpress/icons';

const ALLOWED_BLOCKS = ['core/cover'];
const BUTTONS_TEMPLATE = [['core/cover']];

// Inside buttons block alignment options are not supported.
const alignmentHooksSetting = {
    isEmbedButton: true,
};

function SliderGeneralSettings({attributes,setAttributes}) {
    const {
        arrows,
        dots,
        infinite,
        speed,
        fade,
        autoplay,
        autoplaySpeed,
    } = attributes;
    const [temporaryAutoplaySpeed, setTemporaryAutoplaySpeed] = useState(autoplaySpeed);
    const [temporarySpeed, setTemporarySpeed] = useState(speed);

    const setSpeed = () => {
        if (temporarySpeed !== speed) {
            setAttributes({ speed: parseInt(temporarySpeed)});
        }
    };

    const setAutoplaySpeed = () => {
        if (temporaryAutoplaySpeed !== autoplaySpeed) {
            setAttributes({ autoplaySpeed: parseInt(temporaryAutoplaySpeed)});
        }
    };
    const setFade = () => {
        setAttributes({
            fade: !fade,
        })
        if (fade) {
            setAttributes({
                cssEase: 'linear'
            })
        } else{
            setAttributes({
                cssEase: 'ease'
            })
        }
    }

    return (
        <PanelBody title={__('Slider settings')}>
            <ToggleControl
                label={__('Show arrows')}
                checked={arrows}
                onChange={() =>
                    setAttributes({
                        arrows: !arrows,
                    })
                }
            />
            <ToggleControl
                label={__('Show dots')}
                checked={dots}
                onChange={() =>
                    setAttributes({
                        dots: !dots,
                    })
                }
            />
            <ToggleControl
                label={__('Infinite')}
                checked={infinite}
                onChange={() =>
                    setAttributes({
                        infinite: !infinite,
                    })
                }
            />
            <NumberControl
                label={__('Speed')}
                isShiftStepEnabled={true}
                onBlur={setSpeed}
                onChange={setTemporarySpeed}
                shiftStep={100}
                value={temporarySpeed}
                step={100}
            />
            <ToggleControl
                label={__('Autoplay')}
                checked={autoplay}
                onChange={() =>
                    setAttributes({
                        autoplay: !autoplay,
                    })
                }
            />
            {
                autoplay && (
                    <NumberControl
                        label={__('Autoplay speed')}
                        isShiftStepEnabled={true}
                        onBlur={setAutoplaySpeed}
                        onChange={setTemporaryAutoplaySpeed}
                        shiftStep={500}
                        value={temporaryAutoplaySpeed}
                        step={500}
                    />
                )
            }

            <ToggleControl
                label={__('Fade')}
                checked={fade}
                onChange={setFade}
            />

        </PanelBody>
    )
}
function SliderWrap({settings, props}) {
    let block = select('core/block-editor').getBlock(props.clientId).innerBlocks;
    const slickChildren = block.map((element, i) => {
        const outerHTML = document.getElementById('block-' + element.clientId) ? document.getElementById('block-' + element.clientId).outerHTML : null;
        const withReplaceId = outerHTML ? outerHTML.replace(/id=/g, 'ids=') : outerHTML;
        return (
            <div>
                <div dangerouslySetInnerHTML={{__html: withReplaceId}}/>
            </div>
        )
    });
    return (
        <Slider {...settings}>
            {slickChildren}
        </Slider>
    )
}
function SliderEdit({attributes, isSelected, setAttributes, ...props}) {
    const {
        countSlides,
        arrows,
        dots,
        infinite,
        slidesToShow,
        slidesToScroll,
        speed,
        fade,
        autoplay,
        autoplaySpeed,
        cssEase,
    } = attributes;
    const [tempSliderHTML, setSliderHTML] = useState();

    const isVisibleOnLoad = countSlides > 1;

    const [isVisibleSlider, setVisibleSlider] = useState(!isVisibleOnLoad);


    const getSliderHTML = (id) => {
        let elementId = document.getElementById('block-' + id);
        let slidesHTML = elementId.querySelectorAll('.slick-slider-wrap .wp-block-cover');
        return slidesHTML;
    }
    const addNewSlide = () => {
        dispatch('core/block-editor').insertBlocks(createBlock('core/cover'), 9999, props.clientId);
        setSliderHTML(getSliderHTML(props.clientId));
    }

    const removeSlide = () => {
        if (countSlides > 1) {
            let slidesHTML = getSliderHTML(props.clientId);
            let lastId = (slidesHTML[slidesHTML.length - 1].getAttribute('data-block'));
            dispatch('core/block-editor').removeBlock(lastId, true);
        }

    }

    const countBlockSlides = useSelect((select) => {
        return select('core/block-editor').getBlock(props.clientId).innerBlocks.length;
    }, []);


    useEffect(() => {
        setAttributes({countSlides: countBlockSlides})
        let slidesHTML = getSliderHTML(props.clientId);
        setSliderHTML(slidesHTML);

    }, [countBlockSlides]);
    const settings = {
        dots,
        infinite,
        arrows,
        speed,
        slidesToShow,
        slidesToScroll,
        fade,
        autoplay,
        autoplaySpeed,
        cssEase,
    };

    const changeVisibleSlider = () => {
        setVisibleSlider(!isVisibleSlider);
        if (isVisibleSlider) {
            selectMainBlock();
        }
    }

    const selectMainBlock = () => {
        dispatch('core/block-editor').selectBlock(props.clientId);
    }

    const toolbarControls = [
        {
            icon: pullLeft,
            title: __('Show media on left'),
            isActive: '',
            onClick: () => setAttributes({mediaPosition: 'left'}),
        },
        {
            icon: pullRight,
            title: __('Show media on right'),
            isActive: '',
            onClick: () => setAttributes({mediaPosition: 'right'}),
        },
    ];

    const blockProps = useBlockProps();

    return (
        <div {...blockProps}>
            <InspectorControls>
                <SliderGeneralSettings
                    attributes={attributes}
                    setAttributes={setAttributes}
                />
            </InspectorControls>
            <AlignmentHookSettingsProvider value={alignmentHooksSetting}>
                <BlockControls>
                    {/*<ToolbarGroup controls={ toolbarControls } />*/}
                </BlockControls>
                {!isVisibleSlider && (
                    <Block.div>
                        <Block.div className="gutenberg-slider" onClick={selectMainBlock}>
                            <SliderWrap props={props} settings={settings}/>
                        </Block.div>
                        <Button icon="edit" className="components-button block-editor-button-block-appender"
                                onClick={changeVisibleSlider}>{__('Edit slider')}</Button>
                    </Block.div>

                )}
                <div style={{
                    display: isVisibleSlider
                    ? 'block' : 'none'

                }}>
                <InnerBlocks
                    allowedBlocks={ALLOWED_BLOCKS}
                    template={BUTTONS_TEMPLATE}
                    __experimentalTagName="div"
                    __experimentalPassedProps={{
                        className: 'slick-slider-wrap',
                    }}
                    slides={countSlides}
                    orientation="horizontal"
                    renderAppender={() => (
                        <div>
                            <div className="control-slider">
                                <Button icon="minus" className="components-button block-editor-button-block-appender"
                                        onClick={removeSlide}>
                                    {__('Remove Last Slide')}
                                </Button>
                                <Button icon="plus" className="components-button block-editor-button-block-appender"
                                        onClick={addNewSlide}>
                                    {__('Add Slide')}
                                </Button>
                            </div>
                            <Button icon="cloud-saved" className="components-button block-editor-button-block-appender"
                                    onClick={changeVisibleSlider}>
                                {__('Show slider')}
                            </Button>
                        </div>
                    )}
                />
                </div>

            </AlignmentHookSettingsProvider>
        </div>
    );
}

export default SliderEdit;